import RestrictedUserRoute from "discourse/routes/restricted-user";
export default class PreferencesTracking extends RestrictedUserRoute {}